function isObject(val) {
  return val !== null && (typeof val === 'object' || typeof val === 'function');
}

function toString(val) {
  if (!val) return '';
  if (Array.isArray(val)) {
    return val.join('.');
  }
  return val;
}

export default function get(obj, prop, a, b, c) {
  if (!isObject(obj) || !prop) {
    return obj;
  }

  prop = toString(prop);

  if (a) prop += `.${toString(a)}`;
  if (b) prop += `.${toString(b)}`;
  if (c) prop += `.${toString(c)}`;

  if (prop in obj) {
    return obj[prop];
  }

  const segs = prop.split('.');
  const len = segs.length;
  let i = -1;

  while (obj && ++i < len) {
    let key = segs[i];
    while (key[key.length - 1] === '\\') {
      key = `${key.slice(0, -1)}.${segs[++i]}`;
    }
    obj = obj[key];
  }
  return obj;
}



// WEBPACK FOOTER //
// ./src/utils/get-value.js